import React, { useState, useContext, useEffect } from "react";
import { Select, SelectOption, Card, Button, Switch, Icon, Label, Popover, Tooltip } from "@pmi/nyx-design-system";
import { FiltersContext } from "../../context/filterscontext";
import { ApiContext } from "../../context/apicontext";

// Touchpoints Dropdown code
function Touchpoints({ changeFilter }) {
    const [selectedBtn, setSelectedBtn] = useState("Drive");
    const [catchmentAreas, setCatchmentAreas] = useState({ 1: 'Off', 2: 'Off', 3: 'Off', 4: 'Off', 5: 'Off', 6: 'Off' });
    const [selectedCategory, setSelectedCategory] = useState("All");
    const { isCardOpen, setIsCardOpen, dropdownRefs } = useContext(FiltersContext);
    const {setFilterData,filterData} = useContext(ApiContext);
    const [showTooltip, setShowTooltip] = useState(false);
    const [buttonTooltip, setButtonTooltip] = useState(false);
    const [show, setShow] = useState(false);

    //toast show and hide 
    const showToast = () => {
        setShow(true);
        setTimeout(() => setShow(false), 3000);
    };

    const handleButtonClick = (mode) => {
        setSelectedBtn(mode);
    };

    const handleCatchmentData = (id, value) => {
        setCatchmentAreas((prev) => ({ ...prev, [id]: value }));
        changeFilter(value)
    };

    useEffect(() => {
    }, [changeFilter])
    

    const handleToggle = (id) => {
        setFilterData((prevState) => {
            if (!prevState || !prevState.touchpoints) return prevState;
            showToast();
            return {
                ...prevState,
                touchpoints: prevState.touchpoints.map((point) =>
                    point.id === id ? { ...point, enabled: !point.enabled } : point
                ),
            };
        });
    };

    return (
        <>
            <div className="position-relative" ref={dropdownRefs.touchpoints}>
                <div className="toast-container">
                    {/* Bootstrap Toast */}
                    <div className={`toast custom-toast ${show ? "show" : "hide"}`} role="alert">
                        <div className="d-flex">
                            <div className="toast-body">
                            <Icon className="mt-1" color="#51B121" name="circle-check-filled" />
                                Default filter setup for “Touchpoints” saved
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{marginLeft:'10px'}} >
                <Tooltip align="start" side="bottom" sideOffset={12}  open={showTooltip} 
                  onOpenChange={(isOpen) => setShowTooltip(isOpen)} 
                content={
                    <div>
                        <h6 className="fw-bold">Turn ON/OFF touchpoint visibility</h6><br />
                        <p style={{ fontSize: "13px", color: "#555", wordWrap: 'normal' }}>
                            Use filters to control which touchpoint types are visible on the map.
                        </p>
                        <button className="TouchModel_close" onClick={() => setShowTooltip(false)}>Close</button>
                    </div>
                } trigger={<Button variant="primary" onClick={() => setIsCardOpen({ touchpoints: !isCardOpen.touchpoints, externalData: false })}>
                    Touchpoints <Icon className="mt-1" name={isCardOpen.touchpoints ? "chevron-up" : "chevron-down"} />
                </Button>} />
                </div>
                {/* Dropdown Panel */}
                {isCardOpen.touchpoints && (
                    <Card className="dropdown-panel position-absolute px-1 py-2" width="100%">
                        <div className="p-4 pb-0">
                            <div className="d-flex justify-content-between align-items-center border-bottom pb-2">
                                <h5 className="text-dark fw-bold mb-0">Touchpoints</h5>
                                <a href="#" className="fw-bold text-primary">Reset</a>
                            </div>
                            <Tooltip align="start" side="right" className="custome-tooltip"sideOffset={24}  open={buttonTooltip}
                            onOpenChange={(isOpen) => setButtonTooltip(isOpen)} content={
                                <div>
                                    <h6 className="fw-bold">Save your default filter setup</h6><br />
                                    <p style={{ fontSize: "13px", color: "#555", wordWrap: 'normal' }}>
                                        After you'll decide which touchpoints you'd usually want to have visible, you can save it as a default.
                                    </p>
                                    <button className="TouchModel_close" onClick={() => setButtonTooltip(false)}>Close</button>
                                </div>
                            } trigger={<div className="add-geodata-wrapper my-3">
                                <Button outlined>Save as default</Button>
                            </div>} />
                        </div>

                        <div className="filter-innerdata">
                            {/* Product Category Dropdown */}
                            <Select className="w-100 mt-4 mb-3 product-category-select dropdown-box" label="PRODUCT CATEGORY" placeholder="All" onChange={(val) => setSelectedCategory(val)} size="small">
                                <SelectOption value="electronics">Electronics</SelectOption>
                                <SelectOption value="fashion">Fashion</SelectOption>
                            </Select>

                            {/* Walk / Drive Buttons */}
                            <div role="group" className="flex catchment-btn-wrapper rounded-2 p-1 w-full">
                                {["Drive", "Walk"].map((option) => (
                                    <Button key={option} size="small" variant={selectedBtn === option ? "black" : "white"}
                                        className={
                                            (selectedBtn === option
                                                ? "active bg-white text-black border rounded-2 py-2"
                                                : "border-0 py-0 bg-transparent")
                                            + " px-3 w-50 text-center"
                                        }
                                        onClick={() => handleButtonClick(option)}
                                    >
                                        {option}
                                    </Button>
                                ))}
                            </div>

                            {/* Touchpoints List */}
                            {filterData.touchpoints.map((point) => (
                                <div key={point.id} className="py-3 border-bottom">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className={point.color + "-flag me-2 flag-wrapper"}>
                                                <Icon color="white" name="flag" size="small" className="" />
                                            </div>
                                            <Label className="text-transform-none">
                                                {point.name} ({point.count})
                                            </Label>
                                        </div>
                                        <Switch size="medium" className={`switch ${point.count === "NO DATA" ? "disabled-switch" : ""}`} checked={!!point.enabled} onClick={() => handleToggle(point.id)} />
                                    </div>

                                    {/* Catchment Area */}
                                    {point.enabled && point.count !== "NO DATA" && (
                                        <div className="mt-2 justify-content-center ms-3 ps-3">
                                            <Label className="small fw-bold ms-1">Catchment area (min)</Label>
                                            <div className="d-flex align-items-center p-1 rounded-3 catchment-btn-wrapper">
                                                {["Off", "5", "10", "15"].map((option) => (
                                                    <Button
                                                        key={option}
                                                        size="small"
                                                        variant={catchmentAreas[point.id] === option ? "black" : "white"}
                                                        className={
                                                            (catchmentAreas[point.id] === option
                                                                ? "active bg-white text-black border rounded-2 py-2"
                                                                : "border-0 border-end py-0 bg-transparent")
                                                            + " px-3 w-100"
                                                        }
                                                        onClick={() => handleCatchmentData(point.id, option)}
                                                    >
                                                        {option}
                                                    </Button>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                    </Card>
                )}
            </div>
        </>
    );
}

export default Touchpoints;